"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getOptions = _interopRequireDefault(require("../fetch/get-options"));
var _trackEvent = _interopRequireDefault(require("../../../../../analytics/track-event"));
var _getQueryKey = _interopRequireDefault(require("../../../../product-feed-threads/v2/get-query-key"));
var _patchCart = _interopRequireDefault(require("../api-calls/patch-cart"));
var _updateCartReviewsTotals = _interopRequireDefault(require("../utils/update-cart-reviews-totals"));
var _getQueryKey2 = _interopRequireDefault(require("../get-query-key"));
var _getQueryKey3 = _interopRequireDefault(require("../../../cart_reviews/v2/get-query-key"));
var _getQueryKey4 = _interopRequireDefault(require("../../../partner_cart_reviews/v1/get-query-key"));
var _getQueryKey5 = _interopRequireDefault(require("../../../partner_cart_reviews/v2/get-query-key"));
var _handleWarnings = _interopRequireDefault(require("../utils/handle-warnings"));
var _activeUpdateRequests = require("../utils/active-update-requests");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var removeCartItem = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var id;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          id = _ref.id;
          return _context.a(2, (0, _patchCart["default"])({
            actions: [{
              op: 'remove',
              path: '/items',
              value: {
                id: id
              }
            }]
          }));
      }
    }, _callee);
  }));
  return function removeCartItem(_x) {
    return _ref2.apply(this, arguments);
  };
}();
var getRemoveItemOptions = function getRemoveItemOptions(_ref3) {
  var queryClient = _ref3.queryClient;
  return {
    mutationFn: function mutationFn(_ref4) {
      var id = _ref4.id;
      return removeCartItem({
        id: id
      });
    },
    onMutate: function () {
      var _onMutate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref5) {
        var id, cartQueryKey, currentCart, removedItem;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              id = _ref5.id;
              cartQueryKey = (0, _getQueryKey2["default"])();
              currentCart = queryClient.getQueryData(cartQueryKey);
              removedItem = currentCart === null || currentCart === void 0 ? void 0 : currentCart.items.find(function (item) {
                return item.id === id;
              });
              if (_activeUpdateRequests.activeUpdateRequests.has(id)) {
                _activeUpdateRequests.activeUpdateRequests.get(id).abort();
                _activeUpdateRequests.activeUpdateRequests["delete"](id);
              }
              _context2.n = 1;
              return Promise.all([queryClient.cancelQueries({
                queryKey: (0, _getQueryKey3["default"])()
              }), queryClient.cancelQueries({
                queryKey: (0, _getQueryKey4["default"])()
              }), queryClient.cancelQueries({
                queryKey: (0, _getQueryKey5["default"])()
              })]);
            case 1:
              // optimistically remove item from 'carts'
              queryClient.setQueryData(cartQueryKey, function (currentCart) {
                return _objectSpread(_objectSpread({}, currentCart), {}, {
                  items: currentCart === null || currentCart === void 0 ? void 0 : currentCart.items.filter(function (item) {
                    return item.id !== id;
                  })
                });
              });
              _context2.n = 2;
              return (0, _updateCartReviewsTotals["default"])({
                queryClient: queryClient
              });
            case 2:
              return _context2.a(2, {
                removedItem: removedItem,
                meta: {
                  dispatchCartUpdated: true,
                  dispatchCartCountUpdated: true
                }
              });
          }
        }, _callee2);
      }));
      function onMutate(_x2) {
        return _onMutate.apply(this, arguments);
      }
      return onMutate;
    }(),
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(data, variables, context) {
        var _ref6, quantity, productId, skuId, productCode, gtin, priceInfo, _yield$Promise$all, _yield$Promise$all2, cart, CurrencyEnums, cartId, currency, productFeedData, pid, category, brand, styleColor, content, productName, activeRemoveItemMutations;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _ref6 = (context === null || context === void 0 ? void 0 : context.removedItem) || {}, quantity = _ref6.quantity, productId = _ref6.productId, skuId = _ref6.skuId, productCode = _ref6.productCode, gtin = _ref6.gtin, priceInfo = _ref6.priceInfo;
              _context3.n = 1;
              return Promise.all([queryClient.fetchQuery((0, _getOptions["default"])({
                queryClient: queryClient
              })), window.webShellClient.analytics.utils.getProtoEnums('Currency')]);
            case 1:
              _yield$Promise$all = _context3.v;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              cart = _yield$Promise$all2[0];
              CurrencyEnums = _yield$Promise$all2[1];
              cartId = cart === null || cart === void 0 ? void 0 : cart.id;
              currency = cart === null || cart === void 0 ? void 0 : cart.currency;
              window.webShellClient.analytics.trackAction({
                underlyingAction: {
                  "case": 'coreCommerceV1CartModified',
                  value: {
                    cartId: cartId,
                    operation: {
                      "case": 'itemRemoved',
                      value: {
                        product: {
                          "case": 'consumerProduct',
                          value: {
                            productCode: {
                              value: productCode
                            },
                            gtin: {
                              value: gtin
                            }
                          }
                        },
                        currency: CurrencyEnums[currency === null || currency === void 0 ? void 0 : currency.toUpperCase()],
                        fullPriceTotal: window.webShellClient.analytics.utils.toUnitsNanos(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.fullPriceTotal),
                        currentPriceTotal: window.webShellClient.analytics.utils.toUnitsNanos(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.total),
                        quantity: quantity
                      }
                    }
                  }
                }
              });
              productFeedData = queryClient.getQueryData((0, _getQueryKey["default"])({
                productId: productId,
                styleColor: productCode
              })) || {};
              pid = productFeedData.pid, category = productFeedData.productType, brand = productFeedData.brand, styleColor = productFeedData.styleColor, content = productFeedData.content;
              productName = content === null || content === void 0 ? void 0 : content.title;
              (0, _trackEvent["default"])('Product Removed', {
                brand: brand,
                cartId: cartId,
                category: category,
                cloudProductId: productId,
                currency: currency,
                name: productName,
                price: priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.total,
                prodigyProductId: pid,
                productId: pid,
                quantity: quantity,
                sku: skuId,
                styleColor: styleColor
              }, {
                telemetryData: {
                  cartId: cartId,
                  productCode: productCode,
                  gtin: gtin,
                  quantity: quantity,
                  currency: currency
                },
                usePageAction: true
              });

              // Check for other active remove item mutations
              activeRemoveItemMutations = queryClient.getMutationCache().getAll().filter(function (mutation) {
                return mutation.state.status === 'pending' && mutation.options.mutationFn === removeCartItem;
              }); // Only update cache if this is the last removal mutation
              if (!(activeRemoveItemMutations.length === 0)) {
                _context3.n = 5;
                break;
              }
              queryClient.setQueryData((0, _getQueryKey2["default"])(), data);
              _context3.n = 2;
              return queryClient.invalidateQueries({
                queryKey: (0, _getQueryKey3["default"])()
              });
            case 2:
              _context3.n = 3;
              return queryClient.invalidateQueries({
                queryKey: (0, _getQueryKey4["default"])()
              });
            case 3:
              _context3.n = 4;
              return queryClient.invalidateQueries({
                queryKey: (0, _getQueryKey5["default"])()
              });
            case 4:
              if (!(data !== null && data !== void 0 && data.warnings && data.warnings.length > 0)) {
                _context3.n = 5;
                break;
              }
              _context3.n = 5;
              return (0, _handleWarnings["default"])({
                warnings: data.warnings,
                data: data
              }, queryClient);
            case 5:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function onSuccess(_x3, _x4, _x5) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }()
  };
};
var _default = exports["default"] = getRemoveItemOptions;